<script>
  import { useFocus } from "svelte-navigator";
  import Gallery from "../Components/Gallery.svelte";
  import Footer from "../Components/Footer.svelte";
  const images = [
    {
      src: "logo.webp",
      alt: "Country Cruel logo",
    },
    {
      src: "cadillac.webp",
      alt: "Blue Cadillac",
    },
    {
      src: "band.webp",
      alt: "The band members standing in dark woods",
    },
  ];
  const focus = useFocus();
</script>

<svelte:head>
  <title>Country Cruel</title>
  <meta
    name="description"
    content="Discover, contact and listen to Country Cruel. Loud, hard country music inspired by the likes of John Prine, Dexter Romweber, and Sturgill Simpson."
  />
</svelte:head>
<main use:focus>
  <Gallery {images} />
</main>
<Footer />
